module.exports = __webpack_public_path__ + "static/media/2.25eae43d.jpg";